// extracted by mini-css-extract-plugin
export default {"chatinput-container":"ChatInput_chatinput-container__8EblG"};